import React from 'react'

const ExitToApp = ({
  fill,
  height,
  viewBox = '-10 -10 45 45',
  width,
}) => (
  <svg id="logout_black_24dp-2" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
    <g id="Grupo_5805" data-name="Grupo 5805">
      <path id="Caminho_4504" data-name="Caminho 4504" d="M0,0H24V24H0Z" fill="none"/>
    </g>
    <g id="Grupo_5806" data-name="Grupo 5806">
      <path id="Caminho_4505" data-name="Caminho 4505" d="M17,8,15.59,9.41,17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4ZM5,5h7V3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2h7V19H5Z" fill={fill}/>
    </g>
  </svg>

)

export default ExitToApp